import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { DeliveryZoneModel, HxDeliveryZoneService, HxUiLabelPipe, PagedList, toRouterQueryParams } from 'hx-services';
import { HxBrandSelectComponent, HxCitySelectComponent, HxPagedListDirective } from 'hx-components';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { NzPageHeaderComponent, NzPageHeaderExtraDirective, NzPageHeaderSubtitleDirective, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzButtonComponent, NzButtonGroupComponent } from 'ng-zorro-antd/button';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzCollapseComponent, NzCollapsePanelComponent } from 'ng-zorro-antd/collapse';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { FormsModule } from '@angular/forms';
import { NzRadioComponent, NzRadioGroupComponent } from 'ng-zorro-antd/radio';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { DatePipe, NgFor } from '@angular/common';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';
import { NzPopconfirmDirective } from 'ng-zorro-antd/popconfirm';

@Component({
    selector: 'hc-delivery-zone-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.less'],
  imports: [TranslocoDirective, NzAffixComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzPageHeaderSubtitleDirective, NzPageHeaderExtraDirective, NzButtonComponent, RouterLink, NzIconDirective, NzCollapseComponent, NzCollapsePanelComponent, NzRowDirective, NzColDirective, HxBrandSelectComponent, FormsModule, HxCitySelectComponent, NzRadioGroupComponent, NzRadioComponent, NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzTbodyComponent, NgFor, NzButtonGroupComponent, NzWaveDirective, NzPopconfirmDirective, DatePipe, HxUiLabelPipe, TranslocoPipe]
})
export class DeliveryZoneListComponent extends HxPagedListDirective<DeliveryZoneModel> implements OnInit {

  filter: {
    brandId?: number;
    cityId?: number;
    active?: boolean;
  } = {};

  constructor(
    override router: Router,
    override aRoute: ActivatedRoute,
    private deliveryZoneService: HxDeliveryZoneService,
  ) {
    super(router, aRoute);
    this.limit = 20;
  }

  ngOnInit() {
    this.aRoute.queryParamMap.pipe(takeUntil(this.$destroyed))
      .subscribe(paramMap => {
        const asNumberFn = (name: string, def?: number) => paramMap.get(name) ? Number(paramMap.get(name)) : def;
        const asBooleanFn = (name: string, def?: boolean) => paramMap.get(name) ? paramMap.get(name) === 'true' : def;
        this.filter.brandId = asNumberFn('brandId');
        this.filter.cityId = asNumberFn('cityId');
        this.filter.active = asBooleanFn('active', true);
        if (this.filter.brandId && this.filter.cityId) {
          super.load(paramMap);
        }
      });
  }

  applyFilters() {
    this.router.navigate([], {
      relativeTo: this.aRoute,
      queryParams: toRouterQueryParams(this.filter),
    });
  }

  protected loadList(): Promise<PagedList<DeliveryZoneModel>> {
    return this.deliveryZoneService.getDeliveryZones({
      page: this.page,
      limit: this.limit,
      brandId: this.filter.brandId,
      cityId: this.filter.cityId,
      active: this.filter.active,
    });
  }

  remove(id: number): void {
    this.deliveryZoneService.removeZoneById(id).then(() => this.loadData());
  }
}
